// src/services/api.js
import axios from 'axios';
import API from '../components/config';

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  // Enable credentials to include cookies in cross-origin requests
  withCredentials: true,
});

// Add request interceptor to handle CORS preflight
api.interceptors.request.use(
  config => {
    // For preflight requests
    if (config.method === 'options') {
      config.headers['Access-Control-Request-Method'] = config.method;
      config.headers['Access-Control-Request-Headers'] = 'Content-Type, Authorization';
    }
    return config;
  },
  error => Promise.reject(error)
);

// Add response interceptor to handle CORS errors
api.interceptors.response.use(
  response => response,
  error => {
    // If the error is due to CORS
    if (error.message && error.message.includes('Network Error')) {
      console.error('CORS Error:', error);
      // You could implement a fallback strategy here
      // For example, retry with a different approach or notify the user
    }
    return Promise.reject(error);
  }
);

export default api;
